module.exports = __webpack_public_path__ + "img/art-52.fc20b2d2.png";